'use strict';


import {identity} from './lang';


export default {
  /**
   * @see http://vuejs.org/api/options.html#template
   */
  template: '<div style="width: 100%; height: 100%"></div><slot></slot>',
  /**
   * @see http://vuejs.org/api/options.html#replace
   */
  replace: false,
  /**
   * @see http://vuejs.org/guide/components.html#Prop_Specification
   */
  props: {
    size: {
      type: Object,
      default: {
        width: '100%',
        height: '100%'
      }
    },
    elements: {
      type: Array,
      required: true
    },
    onMouseover: {
      type: Function,
      default: identity
    },
    onMouseout: {
      type: Function,
      default: identity
    },
    onClick: {
      type: Function,
      default: identity
    }
  },
  /**
   * @see http://v1.vuejs.org/api/#watch
   */
  watch: {
    size: {
      /**
       * @param {Number} size.width
       * @param {Number} size.height
       */
      handler(size) {
        this.setSize(size);
      },
      deep: true
    },
    elements: {
      /**
       * @param {Array<Object>} array
       */
      handler(array) {
        this.render(array);
      },
      deep: true
    }
  },
  /**
   * @see http://vuejs.org/api/options.html#methods
   */
  methods: {
    /**
     * @param {Object} config
     * @param {Number} index
     * @private
     */
    __onMouseOver(config, index) {
      let hint = this.pseudoHintElements[index];
      if (hint && hint.transition.base) {
        hint.removeClass(hint.transition.mouseOut);
        hint.addClass(hint.transition.transition);
        hint.addClass(hint.transition.mouseOver);
      }
      this.onMouseover(config);
    },
    /**
     * @param {Object} config
     * @param {Number} index
     * @private
     */
    __onMouseOut(config, index) {
      let hint = this.pseudoHintElements[index];
      if (hint && hint.transition.base) {
        hint.removeClass(hint.transition.mouseOver);
        hint.addClass(hint.transition.transition);
        hint.addClass(hint.transition.mouseOut);
      }
      this.onMouseout(config);
    },
    /**
     * @param {Array<Object>} arrayOfConfigs
     * @returns {Object|null}
     * @private
     */
    __extractBackground(arrayOfConfigs) {
      let bg = arrayOfConfigs.filter(cfg => cfg.type === 'image');
      return bg[0] || null;
    },
    /**
     * @param {Array<Object>} arrayOfConfigs
     * @returns {Array<Object>}
     * @private
     */
    __extractLayers(arrayOfConfigs) {
      return arrayOfConfigs.filter(cfg => cfg.type !== 'image');
    },
    /**
     * @param {Raphael.Paper.Element} groupSvgElement
     * @param {Object} animation.params
     * @param {Number} animation.ms
     * @param {String} animation.easing
     * @private
     */
    __onAnimateSvgElement(groupSvgElement, {params,ms,easing}) {
      groupSvgElement.animate(params, ms, easing);
    },
    /**
     * @see http://raphaeljs.com/reference.html#Paper.add
     * @param {Array<Object>} array
     */
    render(array) {
      this.paper.clear();
      this.frontSvgElements.length = 0;
      this.pseudoHintElements.length = 0;

      let background = this.__extractBackground(array);
      let layers = this.__extractLayers(array);

      if (background) {
        let {width, height} = background;
        this.paper.setViewBox(0, 0, width, height);
        this.paper.add([background]);
        // Setting preserveAspectRatio to 'none' lets you stretch the SVG
        // @see http://bertanguven.com/raphael-js-setsize-function
        this.paper.canvas.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      }

      for(let index = 0; index < layers.length; index++) {
        let config = layers[index];
        let groupSvgElement = this.paper.add([config]); // svg element

        let {events} = config;
        // Attach events handlers
        if (events) {
          for (let key in events) {
            let animationObject = events[key];
            let fn = this.__onAnimateSvgElement.bind(this, groupSvgElement, animationObject);
            groupSvgElement[key](fn);
          }
        }

        groupSvgElement.mouseover(this.__onMouseOver.bind(this, config, index));
        groupSvgElement.mouseout(this.__onMouseOut.bind(this, config, index));
        groupSvgElement.click(this.onClick.bind(this, config));
        this.frontSvgElements.push(groupSvgElement);
      }
    },
    /**
     * @see http://raphaeljs.com/reference.html#Paper.setSize
     * @param {Number} size.width
     * @param {Number} size.height
     */
    setSize({width, height}) {
      this.paper.setSize(width, height);
    }
  },
  /**
   * @see http://vuejs.org/api/options.html#compiled
   */
  compiled() {
    this.paper = new Raphael(this.$el.querySelector('div'));
    this.frontSvgElements = [];
    this.pseudoHintElements = [];
  },
  /**
   * @see http://vuejs.org/api/options.html#attached
   */
  attached() {
    this.setSize(this.size);
    this.render(this.elements);
  },
  /**
   * @see http://vuejs.org/api/options.html#destroyed
   */
  destroyed() {
    this.paper.remove();
    this.frontSvgElements.length = 0;
    this.pseudoHintElements.length = 0;
  }
};


// WEBPACK FOOTER //
// ./src/js/map.js